var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 8.75C2.64168 8.75 2.08334 9.30833 2.08334 10C2.08334 10.6917 2.64168 11.25 3.33334 11.25C4.02501 11.25 4.58334 10.6917 4.58334 10C4.58334 9.30833 4.02501 8.75 3.33334 8.75ZM3.33334 3.75C2.64168 3.75 2.08334 4.30833 2.08334 5C2.08334 5.69167 2.64168 6.25 3.33334 6.25C4.02501 6.25 4.58334 5.69167 4.58334 5C4.58334 4.30833 4.02501 3.75 3.33334 3.75ZM3.33334 13.75C2.64168 13.75 2.08334 14.3167 2.08334 15C2.08334 15.6833 2.65001 16.25 3.33334 16.25C4.01668 16.25 4.58334 15.6833 4.58334 15C4.58334 14.3167 4.02501 13.75 3.33334 13.75ZM5.83334 15.8333H17.5V14.1667H5.83334V15.8333ZM5.83334 10.8333H17.5V9.16667H5.83334V10.8333ZM5.83334 4.16667V5.83333H17.5V4.16667H5.83334Z",
    fill: "#9D9D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/ListIcon.8075800a.svg";
export { ForwardRef as ReactComponent };